import { useEffect, useState } from "react";
import { Form, Button, Row, Col, Container } from "react-bootstrap";
//redux
import { useDispatch } from "react-redux";
import { setFlightDetails } from "_redux/slices/analytics/review-control-panel";
import { PRM_LIGHT_BLUE } from "_styles/colors";

const FlightDetails = ({ setStep }) => {

    const dispatch = useDispatch();

    const [flightNumber, setFlightNumber] = useState("");
    const [paxName, setPaxName] = useState("");
    const [departureDate, setDepartureDate] = useState("");
    const [referenceNumber, setReferenceNumber] = useState("");
    const [disabled, setDisabled] = useState(true);

    useEffect(() => {
        const data = {
            flightNumber: "",
            paxName: "",
            departureDate: "",
            referenceNum: ""
        }
        dispatch(setFlightDetails(data))
    }, [])

    const handleSubmit = (e) => {
        e.preventDefault();

        const data = {
            flightNumber,
            paxName,
            departureDate,
            referenceNumber
        }

        dispatch(setFlightDetails(data));
        setStep("questions")
    };

    useEffect(() => {
        const isValidDateFormat =
            typeof departureDate === "string" &&
            /^\d{4}-\d{2}-\d{2}$/.test(departureDate);
        if (flightNumber.length > 2 && paxName.length > 3 && isValidDateFormat) {
            setDisabled(false);
        } else setDisabled(true)
    }, [flightNumber, paxName, departureDate])

    return (
        <Container
            fluid
            className="d-flex flex-column"
            style={{ minHeight: "100vh", padding: "20px" }}
        >
            <div style={{ flex: 1 }}>
                <h3
                    className="mb-4"
                    style={{ color: PRM_LIGHT_BLUE, paddingBottom: "10px" }}
                >
                    Please fill out these fields to start with survey
                </h3>

                <Form onSubmit={handleSubmit}>
                    <Row className="mb-4">
                        <Col md={6}>
                            <Form.Group controlId="flightNumber">
                                <Form.Label>Flight Number</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter flight number"
                                    value={flightNumber}
                                    onChange={(e) => setFlightNumber(e.target.value?.toUpperCase())}
                                    required
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group controlId="paxName">
                                <Form.Label>Passenger Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter passenger name"
                                    value={paxName}
                                    onChange={(e) => setPaxName(e.target.value)}
                                    required
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group controlId="referenceNumber">
                                <Form.Label>Reference number (optional)</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter reference number"
                                    value={referenceNumber}
                                    onChange={(e) => setReferenceNumber(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-4">
                        <Col md={6}>
                            <Form.Group controlId="departureDate">
                                <Form.Label>Departure Date</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={departureDate}
                                    onChange={(e) => setDepartureDate(e.target.value)}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </div>

            {/* Fixed Bottom Button */}
            <div
                style={{
                    position: "sticky",
                    bottom: 0,
                    background: "#fff",
                    padding: "15px 0",
                }}
            >
                <Button
                    variant="primary"
                    type="submit"
                    disabled={disabled}
                    style={{ width: "100%" }}
                    onClick={handleSubmit}
                >
                    Start survey
                </Button>
            </div>
        </Container>
    );

};

export default FlightDetails;
